import React from 'react';
import './MotionGraphicsTopic.css'; // O un CSS condiviso se hai stili comuni di layout
// Importa solo il CSS che è comune a tutti i topic che usano questo layout.
// Se le classi come 'description-container', 'title', 'content' sono definite lì, è OK.

/**
 * BaseTopicLayout Component.
 * Fornisce un layout comune per le pagine dei topic, inclusa l'area della descrizione
 * e la gestione del passaggio delle prop relative ai cookie ai figli.
 *
 * @param {object} props - Props del componente.
 * @param {string} props.title - Titolo principale del topic (es. "Motion Graphics").
 * @param {string} props.descriptionContent - Contenuto descrittivo del topic. Supporta \n per le nuove righe.
 * @param {React.Node} props.children - Contenuto specifico del topic da renderizzare all'interno del layout.
 * @param {function} [props.setHasAcceptedTrackingCookies=()=>{}] - Setter per lo stato globale dei cookie di tracciamento.
 * @param {boolean} [props.hasAcceptedTrackingCookies=true] - Stato globale dei cookie di tracciamento.
 */
function BaseTopicLayout({ 
    title = "", 
    descriptionContent = "",
    smallText = "",
    children, 
    setHasAcceptedTrackingCookies = () => {}, 
    hasAcceptedTrackingCookies = true 
}) {
    // Funzione helper per renderizzare la descrizione con le nuove righe
    const renderDescriptionWithNewlines = (text) => {
        if (!text) return null;
        return text.split('\n').map((part, index) => (
            <React.Fragment key={index}>
                {part.trim()}
                {index < text.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    // DEBUG: logga le props ricevute dal BaseTopicLayout
    // console.log("BaseTopicLayout: hasAcceptedTrackingCookies:", hasAcceptedTrackingCookies);

    // Renderizza i figli passando le prop dei cookie.
    // Questo è fondamentale perché i figli (come MultiGallery) possano riceverle.
    const childrenWithProps = React.Children.map(children, child => {
        // Clona ogni figlio e aggiungi le prop se è un elemento React valido
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { 
                setHasAcceptedTrackingCookies: setHasAcceptedTrackingCookies,
                hasAcceptedTrackingCookies: hasAcceptedTrackingCookies
            });
        }
        return child;
    });

    return (
        <div>
        <h2 className="title text-style-04"> {title} </h2>
            <div id="description-container">
                {/*<span className="title">{title}</span>*/}
                
                <span className="content">
                    {renderDescriptionWithNewlines(descriptionContent)} <br/>
                    
                    <span className="content-small"> {smallText}</span>
                </span>
                
                <span className="content">
                    
                </span>
            </div>
            {/* Renderizza il contenuto specifico del topic qui */}
            {childrenWithProps}
        </div>
    );
}

export default BaseTopicLayout;
